import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import enUS from 'antd/locale/en_US';
import 'antd/dist/reset.css';
import './App.css';

import TeacherDashboard from './components/TeacherDashboard';
import TeacherLogin from './components/TeacherLogin';
import StudentTest from './components/StudentTest';
import TestStatistics from './components/TestStatistics';
import HomePage from './components/HomePage';
import FeedbackBoard from './components/FeedbackBoard';
import StudentManagement from './components/StudentManagement';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import QuestionBank from './components/QuestionBank';
import AdvancedStatistics from './components/AdvancedStatistics';
import NotFound from './components/NotFound';

function App() {
  return (
    <HelmetProvider>
      <ConfigProvider locale={enUS}>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/teacher/login" element={<TeacherLogin />} />
              <Route path="/teacher" element={<TeacherDashboard />} />
              <Route path="/teacher/students" element={<StudentManagement />} />
              <Route path="/teacher/question-bank" element={<QuestionBank />} />
              <Route path="/super-admin" element={<SuperAdminDashboard />} />
              <Route path="/test/:testId" element={<StudentTest />} />
              <Route path="/statistics/:testId" element={<TestStatistics />} />
              <Route path="/statistics/:testId/advanced" element={<AdvancedStatistics />} />
              <Route path="/admin/feedback-board-2024" element={<FeedbackBoard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </ConfigProvider>
    </HelmetProvider>
  );
}

export default App;
